/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Details_company = {
    readonly id: string;
    readonly isUsingProjectAllocation: boolean | null;
    readonly " $refType": "Details_company";
};
export type Details_company$data = Details_company;
export type Details_company$key = {
    readonly " $data"?: Details_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Details_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Details_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsingProjectAllocation",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'b012cccfdfd58b5bebc8f073a4ec1d2b';
export default node;
